import { io } from "socket.io-client";
import config from "config";
// import * as types from "../actionTypes";
// import { setWsConnection } from "services/general";

const socket = io(config.WEBSOCKET_URL, {
  extraHeaders: {
    "ngrok-skip-browser-warning": "69420",
  },
});

export const WSconnect = () => {
  return new Promise<void>((resolve, reject) => {
    socket.on("connect", () => {
      resolve();
    });
    socket.on("connect_error", (error) => {
      reject(error);
    });

    socket.timeout(5000).connect();
  });
};

export const WSdisconnect = () => {
  return socket.disconnect();
};

export const WSemit = (event: string, data: any) => {
  return socket.timeout(5000).emit(event, data, (err: any, response: any) => {
    if (err) {
      console.error();
    } else {
      console.log(response);
    }
  });
  // change status
  // change icon
  // pop alert
};

export const WSlisten = (event: string, action: any) => {
  return socket.on(event, action);
  // change status
  // change icon
  // pop alert
};

export const WSoff = (event: string) => {
  // console.log(socket, event, action);
  return socket.off(event);
  // change status
  // change icon
  // pop alert
};
